'use client';
import NavCard from '@/components/NavigationCard/NavCard';
import SettingIcon from '@/components/icons/Action/SettingIcon';
import WorkIcon from '@/components/icons/Document/WorkIcon';
import PeopleIcon from '@/components/icons/User/PeopleIcon';
import PersonIcon from '@/components/icons/User/PersonIcon';
import { Footer } from '@/containers';
import useNavigate from '@/hooks/useNavigate';
import { useAppSelector } from '@/store/hooks';
import getEnv from '@/utils/env';
import styles from './page.module.css';

export default function Menu() {
  const profil = getEnv().PROFIL;
  const selectedSte = useAppSelector((state) => state.selectedSte.societe);
  const navigate = useNavigate();
  const choices = [
    {
      title: 'Paramétrer la société',
      desc: 'Définir les paramétres de ' + selectedSte.name,
      icon: <SettingIcon className={styles['icon']} />,
      redirectUrl: 'societe/modifier',
    },
    {
      title: 'Gérer les numéros d’agrément',
      desc: 'Ajouter modifier, supprimer un numéro d’agrément',
      icon: <WorkIcon className={styles['icon']} />,
      redirectUrl: 'numero-agrement',
    },
    {
      title: 'Gérer des employés',
      desc: 'Ajouter, modifier, supprimer, activer, désactiver un employé',
      icon: <PeopleIcon className={styles['icon']} />,
      redirectUrl: 'employees',
    },
    {
      title: 'Gérer des administrateurs',
      desc: 'Ajouter, modifier, supprimer un administrateur',
      icon: <PersonIcon className={styles['icon']} />,
      redirectUrl: 'administrators',
    },
  ];

  function renderChoices() {
    if (profil == 'PARTENAIRE') return [choices[2], choices[3]];
    else return choices;
  }

  return (
    <>
      <div className={styles['content']}>
        <h3 className={styles['title']}>
          Quelle action souhaitez-vous réaliser ?
        </h3>
        <div className={styles['cards']}>
          {renderChoices().map((value, index) => (
            <NavCard
              onClick={() => navigate(`${value.redirectUrl}`)}
              key={index}
              title={value.title}
              description={value.desc}
              Icon={value.icon}
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
